<app-button
*ngIf="currentTab == this.enumTabNames.INSTOCK"
class="{{marginClass}}"
imgUrl=""
[buttonLable]="buttonName" >
</app-button>
<div 
appClickOutside (clickOutside)="closeList()"
class="d-flex position-relative">
<app-button
imgUrl=""
[buttonLable]="name"
class="{{marginClass}} {{btnClass}}"
[inputReadonly]="disabled"
[buttonClass]="innerBtnClass"
(click)="disabled?null:showlist = !showlist">
</app-button>
<div class="list-wrap"
     *ngIf="showlist && optionList?.length > 0"
     [ngClass]="classActive"
     [ngStyle]="{ width: optionWidth }">
  <ol class="add-list-item" >
    <li *ngFor="let listitem of optionList; let i = index">
      <span
        (click)="seletedItem(i, listitem)"
        [ngClass]="{ activeName: listitem.selected }">
        {{ listitem.name }}
      </span>
    </li>
  </ol>
</div>


</div>